/**
 * <s-chat-popup> — a blinking round Telegram button that is always in the corner,
 * plus the chat prompt card that opens on its own after a delay. Closing the card
 * returns to the button; the card does not auto-open again for a day, but the
 * button stays and opens it any time.
 */
const STORAGE_KEY = 'keks-chat-popup-dismissed';
const DAY_MS = 24 * 60 * 60 * 1000;

class SChatPopup extends HTMLElement {
  #ac;
  #timer;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    const bubble = this.querySelector('[data-chat-popup-reopen]');
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    const openCard = () => {
      if (bubble) bubble.hidden = true;
      if (!dialog.open) dialog.show();
    };

    dialog.addEventListener('close', () => {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) { /* storage unavailable */ }
      if (bubble) bubble.hidden = false;
    }, { signal });

    // The round button sends a custom --show command to open the card.
    dialog.addEventListener('command', (event) => {
      if (event.command === '--show') openCard();
    }, { signal });

    if (this.hasAttribute('data-design-mode')) {
      openCard();
      return;
    }

    let dismissedAt = 0;
    try { dismissedAt = Number(localStorage.getItem(STORAGE_KEY)) || 0; } catch (e) { /* storage unavailable */ }
    if (Date.now() - dismissedAt < DAY_MS) return;

    const delay = Number(this.dataset.delay || 5) * 1000;
    this.#timer = setTimeout(openCard, delay);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-chat-popup')) customElements.define('s-chat-popup', SChatPopup);
